import React, { useState, useEffect } from 'react';
import './Admin.css';

const HistoryManager = () => {
    const [blocks, setBlocks] = useState([]);
    const [settings, setSettings] = useState({ title: 'ИСТОРИЯ' });
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');
    const [uploading, setUploading] = useState({});

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        setLoading(true);
        try {
            const [blocksRes, settingsRes] = await Promise.all([
                fetch('http://localhost:4000/api/content/history?field=blocks'),
                fetch('http://localhost:4000/api/content/history?field=settings')
            ]);

            const blocksData = await blocksRes.json();
            const settingsData = await settingsRes.json();

            let allBlocks = blocksData.data || [];
            allBlocks.sort((a, b) => (a.order || 0) - (b.order || 0));

            setBlocks(allBlocks);
            setSettings(settingsData.data || { title: 'ИСТОРИЯ' });
        } catch (error) {
            console.error('Ошибка загрузки:', error);
            setMessage('❌ Ошибка загрузки');
        } finally {
            setLoading(false);
        }
    };

    const saveBlocks = async (blocksToSave) => {
        try {
            await fetch('http://localhost:4000/api/content/history', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ field: 'blocks', data: blocksToSave })
            });
        } catch (error) {
            console.error('Ошибка сохранения:', error);
        }
    };

    const saveSettings = async (newSettings) => {
        try {
            await fetch('http://localhost:4000/api/content/history', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ field: 'settings', data: newSettings })
            });
        } catch (error) {
            console.error('Ошибка сохранения:', error);
        }
    };

    const showMessage = (text) => {
        setMessage(text);
        setTimeout(() => setMessage(''), 2000);
    };

    const addBlock = () => {
        const newBlock = {
            id: Date.now().toString(),
            type: 'text',
            text: 'Новый блок текста...',
            imageUrl: null,
            imagePosition: 'right',
            order: blocks.length
        };
        const newBlocks = [...blocks, newBlock];
        setBlocks(newBlocks);
        saveBlocks(newBlocks);
        showMessage('✅ Блок добавлен');
    };

    const updateBlock = (id, field, value) => {
        const updatedBlocks = blocks.map(b =>
            b.id === id ? { ...b, [field]: value } : b
        );
        setBlocks(updatedBlocks);
        saveBlocks(updatedBlocks);
        showMessage('✅ Сохранено');
    };

    const deleteBlock = (id) => {
        if (!confirm('Удалить блок?')) return;
        const filteredBlocks = blocks.filter(b => b.id !== id);
        const reorderedBlocks = filteredBlocks.map((b, idx) => ({ ...b, order: idx }));
        setBlocks(reorderedBlocks);
        saveBlocks(reorderedBlocks);
        showMessage('✅ Блок удален');
    };

    const updateSetting = (key, value) => {
        const newSettings = { ...settings, [key]: value };
        setSettings(newSettings);
        saveSettings(newSettings);
        showMessage('✅ Настройки сохранены');
    };

    const handleImageUpload = async (blockId, file) => {
        if (!file) return;

        setUploading(prev => ({ ...prev, [blockId]: true }));
        const formData = new FormData();
        formData.append('historyImage', file);

        try {
            const response = await fetch('http://localhost:4000/api/upload/history-image', {
                method: 'POST',
                body: formData
            });

            if (response.ok) {
                const data = await response.json();
                updateBlock(blockId, 'imageUrl', data.url);
                showMessage('✅ Изображение загружено');
            }
        } catch (error) {
            console.error('Ошибка загрузки:', error);
            showMessage('❌ Ошибка загрузки изображения');
        } finally {
            setUploading(prev => ({ ...prev, [blockId]: false }));
        }
    };

    const moveBlock = (id, direction) => {
        const index = blocks.findIndex(b => b.id === id);
        if (direction === 'up' && index === 0) return;
        if (direction === 'down' && index === blocks.length - 1) return;

        const newBlocks = [...blocks];
        const newIndex = direction === 'up' ? index - 1 : index + 1;
        [newBlocks[index], newBlocks[newIndex]] = [newBlocks[newIndex], newBlocks[index]];

        const reorderedBlocks = newBlocks.map((b, idx) => ({ ...b, order: idx }));
        setBlocks(reorderedBlocks);
        saveBlocks(reorderedBlocks);
        showMessage('✅ Порядок изменен');
    };

    if (loading) return <div className="loading-spinner">Загрузка истории...</div>;

    return (
        <div className="history-manager">
            <h2>📖 Управление блоком "История"</h2>

            {message && <div className="message success">{message}</div>}

            {/* Настройки */}
            <div className="settings-section">
                <h3>⚙️ Настройки</h3>
                <div className="settings-grid">
                    <div className="setting-item">
                        <label>Заголовок</label>
                        <input
                            type="text"
                            value={settings.title}
                            onChange={(e) => updateSetting('title', e.target.value)}
                        />
                    </div>
                </div>
            </div>

            {/* Блоки */}
            <div className="blocks-section">
                <div className="section-header">
                    <h3>📝 Блоки истории</h3>
                    <button onClick={addBlock} className="add-block-btn">+ Добавить блок</button>
                </div>

                {blocks.map((block, idx) => (
                    <div key={block.id} className="history-block">
                        <div className="block-header">
                            <span className="block-order">Блок {idx + 1}</span>
                            <div className="block-actions">
                                <button
                                    onClick={() => moveBlock(block.id, 'up')}
                                    className="move-btn"
                                    disabled={idx === 0}
                                >
                                    ↑
                                </button>
                                <button
                                    onClick={() => moveBlock(block.id, 'down')}
                                    className="move-btn"
                                    disabled={idx === blocks.length - 1}
                                >
                                    ↓
                                </button>
                                <button onClick={() => deleteBlock(block.id)} className="delete-block-btn">
                                    🗑️
                                </button>
                            </div>
                        </div>

                        <div className="block-content">
                            <div className="block-field">
                                <label>Текст</label>
                                <textarea
                                    value={block.text}
                                    onChange={(e) => updateBlock(block.id, 'text', e.target.value)}
                                    rows={6}
                                    className="block-textarea"
                                    placeholder="Введите текст. Используйте **текст** для жирного выделения"
                                />
                                <div className="hint">💡 **жирный текст**</div>
                            </div>

                            <div className="block-field">
                                <label>Расположение фото</label>
                                <select
                                    value={block.imagePosition}
                                    onChange={(e) => updateBlock(block.id, 'imagePosition', e.target.value)}
                                    className="block-select"
                                >
                                    <option value="left">Фото слева</option>
                                    <option value="right">Фото справа</option>
                                </select>
                            </div>

                            <div className="block-field">
                                <label>Фото</label>
                                {block.imageUrl ? (
                                    <div className="block-image-preview">
                                        <img src={`http://localhost:4000${block.imageUrl}`} alt="block" />
                                        <div className="image-buttons">
                                            <label className="upload-image-btn">
                                                🔄 Заменить
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => handleImageUpload(block.id, e.target.files[0])}
                                                    style={{ display: 'none' }}
                                                />
                                            </label>
                                            <button
                                                onClick={() => updateBlock(block.id, 'imageUrl', null)}
                                                className="remove-image-btn"
                                            >
                                                ✕ Удалить
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="image-upload-area">
                                        <label className="upload-image-btn">
                                            {uploading[block.id] ? '⏳ Загрузка...' : '📸 Загрузить фото'}
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) => handleImageUpload(block.id, e.target.files[0])}
                                                style={{ display: 'none' }}
                                            />
                                        </label>
                                        <p className="hint">Рекомендуемый размер: 500x400 пикселей</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                ))}

                {blocks.length === 0 && (
                    <div className="empty-state">Нет блоков. Нажмите "+ Добавить блок"</div>
                )}
            </div>

            {/* Предпросмотр */}
            <div className="preview-section">
                <h3>🖼️ Предпросмотр на сайте</h3>
                <div className="site-preview history-preview">
                    <h4>{settings.title}</h4>
                    {blocks.map((block, idx) => (
                        <div key={block.id} className={`preview-block preview-${block.imagePosition}`}>
                            {block.imageUrl && (
                                <div className="preview-block-image">
                                    <img src={`http://localhost:4000${block.imageUrl}`} alt="" />
                                </div>
                            )}
                            <div className="preview-block-text">
                                <p>{block.text.substring(0, 100)}...</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default HistoryManager;